import $ from "jquery";
import {$body} from '../../../Constants';
import HtmlElement from '../../../Elements/HtmlElement';

/**
 * Catalog Downloads
 */
const CatalogDownloads = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		CATALOG_DOWNLOADS: '.catalogDownloads'
	};

	/**
	 * Catalog Downloads
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class CatalogDownloads extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();

			// First element
			this.$firstCatalog = this.$element.find('.row').eq(0);

			// First to active
			this.$firstCatalog.addClass('act');

			this.$rightContainer = this.$element.find('.column.right');

			const linkAttrs = {
				'catalog': this.$firstCatalog.find('> a').data('catalog'),
				'download': this.$firstCatalog.find('> a').data('download'),
				'remember': this.$firstCatalog.find('> a').data('remember'),
				'browse': this.$firstCatalog.find('> a').data('browse'),
				'size': this.$firstCatalog.find('> a').data('size')
			};

			this.setContent(linkAttrs);

			this.$element.find('.row > a').click((e) => {
				e.preventDefault();

				const $target = $(e.currentTarget);

				this.$element.find('.row').removeClass('act');

				$target.closest('.row').addClass('act');

				linkAttrs['catalog'] = $target.data('catalog');
				linkAttrs['download'] = $target.data('download');
				linkAttrs['remember'] = $target.data('remember');
				linkAttrs['browse'] = $target.data('browse');
				linkAttrs['size'] = $target.data('size');

				this.setContent(linkAttrs);
			});
		}

		setContent(linkAttrs) {
			this.$rightContainer.find('img').attr('src', linkAttrs['catalog']);
			this.$rightContainer.find('.actions > a').attr('href', linkAttrs['download']);
			// this.$rightContainer.find('.column.two > a').attr('href', linkAttrs['remember']);
			if(linkAttrs['browse'] == '') {
				this.$rightContainer.find('.column.three > a').hide();
			} else {
				this.$rightContainer.find('.column.three > a').attr('href', linkAttrs['browse']);
				this.$rightContainer.find('.column.three > a').show();
			}
			this.$rightContainer.find('.size').html('(' + linkAttrs['size'] + ')');
		}
	}

	return CatalogDownloads._getElements($body.find(Selector.CATALOG_DOWNLOADS), CatalogDownloads);
})();

export default CatalogDownloads;
